import React from 'react';
import { UsersIcon, MessageSquareIcon, UsersRoundIcon, BarChart3Icon, TrendingUpIcon } from 'lucide-react';
interface ConnectionsStatsWidgetProps {
  title: string;
  value: string;
  trend: string;
  icon: 'users' | 'messages' | 'groups' | 'chart';
}
const ConnectionsStatsWidget: React.FC<ConnectionsStatsWidgetProps> = ({
  title,
  value,
  trend,
  icon
}) => {
  const getIcon = () => {
    switch (icon) {
      case 'users':
        return <UsersIcon size={20} className="text-gray-500" data-id="element-514" />;
      case 'messages':
        return <MessageSquareIcon size={20} className="text-gray-500" data-id="element-515" />;
      case 'groups':
        return <UsersRoundIcon size={20} className="text-gray-500" data-id="element-516" />;
      case 'chart':
        return <BarChart3Icon size={20} className="text-gray-500" data-id="element-517" />;
      default:
        return null;
    }
  };
  return <div className="bg-white rounded-lg p-4 border border-gray-200" data-id="element-518">
      <div className="flex items-center justify-between mb-2" data-id="element-519">
        <span className="text-sm text-gray-500" data-id="element-520">{title}</span>
        {getIcon()}
      </div>
      <div className="flex items-baseline justify-between" data-id="element-521">
        <span className="text-2xl font-semibold text-gray-800" data-id="element-522">{value}</span>
        <span className="text-xs text-custom-green" data-id="element-523">{trend}</span>
      </div>
    </div>;
};
export default ConnectionsStatsWidget;